import Common from "./module/common.js";
import Ukiyo from "ukiyojs";


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
imageUkyo
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
const els = document.querySelectorAll(".ukiyo");
els.forEach((el) => {
  const parallax = new Ukiyo(el,{wrapperClass: "wrapper"});
});



/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* back_to_top
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
// function backtotop_func() {
//   "use strict";
//   var win = $(window),
//   back_to_top = $('.backtotop'),
//   showClass = 'backtotop-visible',
//   scroll_top_duration = 700;
//   win.on('load scroll', function () {
//     var  thisScrollTop = $(this).scrollTop(),
//     scrollBottom = win.scrollTop() + win.height();
//     if (thisScrollTop > 500) {
//       back_to_top.addClass(showClass);
//     } else {
//       back_to_top.removeClass(showClass);
//     }
//   });
//   var clickEventType = ((window.ontouchstart !== null) ? 'click' : 'touchstart');
//   back_to_top.on(clickEventType, function () {
//   $('body,html').animate({
//     scrollTop: 0,
//     }, scroll_top_duration);
//   });
// }


   // TO TOP BUTTON
function backtotop_func() {
  var showFlag = false;
  var topBtn = $('.pagetop');
  topBtn.css('bottom', '-100px');
  // $(window).scroll(function () {
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 100) {
      if (showFlag === false) {
        showFlag = true;
        topBtn.stop().animate({
          bottom: '50px'
        },200);
      }
    } else {
      if (showFlag) {
        showFlag = false;
        topBtn.stop().animate({
          bottom: '-100px'
        }, 200);
      }
    }
  });
  topBtn.on("click", function () {
    $('body,html').animate({scrollTop: 0}, 500);
    return false;
  });
  topBtn.on("click", function () {
    $('html,body').animate({scrollTop: 0}, 'fast');
    return false;
  });
}

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* toggleBtn
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
function toggleBtn_func() {
  //デバイス判定（タッチが有効か否か）
  var isTouchDevice = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch; //デバイス判定によるイベントの決定

  var eventType = isTouchDevice ? 'touchend' : 'click';
  $(".menuBtn").on("click", function () {
    $("html").toggleClass("menuBtn-open");
    $(".spNavi-links li").toggleClass('is-view');
    $(".spNavi-footer").toggleClass('is-view'); 
  });
  var window_width = window.innerWidth;
  var timer = false;
  $(window).on('orientationchange', function () {
    var resize_width = window.innerWidth;

    if (window_width != resize_width) {
      if (timer !== false) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        $("html").removeClass("menuBtn-open");
        $(".spNavi-links li").removeClass('is-view');
        $(".spNavi-footer").removeClass('is-view'); 
        window_width = resize_width;
      }, 100);
    }
  }); //メニューの中クリックしたらとじる

  $('.spNavi a').on('click', function () {
    $("html").removeClass("menuBtn-open");
    $(".spNavi-links li").removeClass('is-view');
    $(".spNavi-footer").removeClass('is-view'); 
  }); // 表示したポップアップ以外の部分をクリックしたとき

  $(document).on('click touchend', function (event) {
    if ($("html").hasClass("menuBtn-open")) {
      if (!$(event.target).closest(".spNavi").length && !$(event.target).closest(".header").length) {
        $("html").removeClass("menuBtn-open");
        $(".spNavi-links li").removeClass('is-view');
        $(".spNavi-footer").removeClass('is-view'); 
      }
    }
  });
}

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
スマホのみTEL有効
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
function telLink_func() {
  var agent = navigator.userAgent;
  if (agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){

    $('.tel').each(function() {
      var str = $(this).html();
      if ($(this).children().is('img')) {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
      } else {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
      }
    });
  }
};


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * inview
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
function inview_func() {
  var inviewDeferred = $.Deferred();

  if ($('body').hasClass('inview--use')) {
    inviewDeferred.resolve();
  }

  inviewDeferred.done(function () {
    inview_curtain(); //隠したいアイテムをspanやdivでくくりそこにclass名（inview_curtain）
    inview_fadeInZoom(); //フェードインclass名（inview_fadeIn）
    inview_fadeIn(); //フェードインclass名（inview_fadeIn）
    inview_fadeInUp(); //フェードインclass名（inview_fadeInUp）
    inview_zoomIn();
    inview_textyle(); //テキストエフェクトclass名（inview_textyle）
    inview_bounceIn();
    inview_txtIn();
    inview_navIn();
    effectFlug(); //inviewでフラグ立てたいとき用class名（effectFlug）をつけたものに（effect_start）クラスがつく
  });


function effectFlug() {
  $('.effectFlug').one('inview', function (event, isInView) {

  $(this).addClass('effectFlug--now');
  if (isInView) {
    $('.effectFlug--now').each(function (i) {
      $(this).delay(i * 200).queue(function () {
        $(this).addClass('animated animate__effectFlug').removeClass('effectFlug--now effectFlug').dequeue();
      });
    });
  }
});
}

function inview_fadeInZoom() {
  $('.inview_fadeInZoom').one('inview', function (event, isInView) {
    $(this).addClass('inview_fadeInZoom--now');
    if (isInView) {
      $('.inview_fadeInZoom--now').each(function (i) {
        $(this).delay(i * 100).queue(function () {
          $(this).addClass('animated animate__fadeInZoom').removeClass('inview_fadeInZoom--now inview_fadeInZoom').dequeue();
        });
      });
    }
  });
}

function inview_fadeIn() {
  $('.inview_fadeIn').one('inview', function (event, isInView) {
    $(this).addClass('inview_fadeIn--now');
      if (isInView) {
        $('.inview_fadeIn--now').each(function (i) {
          $(this).delay(i * 100).queue(function () {
            $(this).addClass('animated animate__fadeIn').removeClass('inview_fadeIn--now inview_fadeIn').dequeue();
          });
        });
      }
  });
}

function inview_fadeInUp() {
  $('.inview_fadeInUp').one('inview', function (event, isInView) {
    $(this).addClass('inview_fadeInUp--now');
      if (isInView) {
        $('.inview_fadeInUp--now').each(function (i) {
          $(this).delay(i * 100).queue(function () {
            $(this).addClass('animated animate__fadeInUp').removeClass('inview_fadeInUp--now inview_fadeInUp').dequeue();
          });
        });
      }
  });
}

function inview_zoomIn() {
  $('.inview_zoomIn').one('inview', function (event, isInView) {
    $(this).addClass('inview_zoomIn--now');
      if (isInView) {
        $('.inview_zoomIn--now').each(function (i) {
          $(this).delay(i * 100).queue(function () {
            $(this).addClass('animated animate__zoomIn').removeClass('inview_zoomIn--now inview_zoomIn').dequeue();
          });
        });
      }
  });
}

function inview_curtain() {
  $('.inview_curtain').one('inview', function (event, isInView) {
    $(this).addClass('inview_curtain--now');
      if (isInView) {
        $('.inview_curtain--now').each(function (i) {
          $(this).delay(i * 200).queue(function () {
            $(this).addClass('curtain-start').removeClass('inview_curtain--now').dequeue();
          });
        });
      }
  });
}

function inview_textyle() {
  $('.inview_textyle').one('inview', function (event, isInView) {
    $(this).addClass('inview_textyle--now');
      if (isInView) {
        $('.inview_textyle--now').each(function (i) {
          $(this).delay(i * 150).queue(function () {
          $(this).textyle({
              // duration : 400, //エフェクト時間(ミリ秒)
              delay: 50, //文字間のエフェクト間隔(ミリ秒)
              easing: 'swing', //エフェクトのイージングパターン
          });
          $(this).addClass('textyle').removeClass('inview_textyle--now').dequeue();
          });
        });
    }
  });
}

function inview_bounceIn() {
  $('.inview_bounceIn').one('inview', function (event, isInView) {
    $(this).addClass('inview_bounceIn--now');
      if (isInView) {
        $('.inview_bounceIn--now').each(function (i) {
          $(this).delay(i * 100).queue(function () {
            $(this).addClass('animated animate__bounceIn').removeClass('inview_bounceIn--now inview_bounceIn').dequeue();
          });
        });
      }
    });
}

function inview_txtIn() {
  $('.inview_txtIn').one('inview', function (event, isInView) {
    $(this).addClass('inview_txtIn--now');
      if (isInView) {
        $('.inview_txtIn--now').each(function (i) {
          $(this).delay(i * 100).queue(function () {
            $(this).addClass('animated animate__txtIn').removeClass('inview_txtIn--now inview_txtIn').dequeue();
          });
        });
      }
    });
}

function inview_navIn() {
  $('.inview_navIn').one('inview', function (event, isInView) {
    $(this).addClass('inview_navIn--now');
    if (isInView) {
    $('.inview_navIn--now').each(function (i) {
    $(this).delay(i * 100).queue(function () {
    $(this).addClass('animated animate__navIn').removeClass('inview_navIn--now inview_navIn').dequeue();
    });
    });
    }
  });
}

}

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
QAアコーディオン
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
function qa_func() { $(".qa-toggle").on("click", function() {
    $(this).next().slideToggle(200);
    $(this).toggleClass("open",200);
  });
}


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
Jquery 関連　呼び出し
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
$(function () {
  toggleBtn_func();
  inview_func();
  backtotop_func();
  qa_func();

  // telLink_func();
  // smooth_scroll_func();
})

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
smoothscroll 呼び出し
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
$(document).ready(function() {
  $('a[href*="#"]').smoothScroll({
		offset: -100,
    speed: 400,
	});
});
